(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-kexpdp-carousel]:not([data-kexpdp-ready])').forEach((carousel) => {
      carousel.dataset.kexpdpReady = 'true';
      const slides = [...carousel.querySelectorAll('[data-kexpdp-slide]')];
      if (slides.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let index = 0;
      const delay = Math.max(2500, Number(carousel.dataset.delay || 5500));
      setInterval(() => {
        slides[index].classList.remove('is-active');
        index = (index + 1) % slides.length;
        slides[index].classList.add('is-active');
      }, delay);
    });
    root.querySelectorAll('[data-kexpdp-cycle]:not([data-kexpdp-ready])').forEach((cycle) => {
      cycle.dataset.kexpdpReady = 'true';
      const items = [...cycle.querySelectorAll('[data-kexpdp-cycle-item]')];
      if (items.length < 2 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      let index = Math.max(0, items.findIndex((item) => item.classList.contains('is-auto-active')));
      const delay = Math.max(2500, Number(cycle.dataset.delay || 2500));
      setInterval(() => {
        items[index].classList.remove('is-auto-active');
        index = (index + 1) % items.length;
        items[index].classList.add('is-auto-active');
      }, delay);
    });
    const loadZoomImage = (zoomLink) => new Promise((resolve) => {
      const zoomImage = zoomLink.querySelector('.js-zoom-image');
      if (!zoomImage) {
        resolve(null);
        return;
      }
      const source = zoomImage.dataset.src;
      if (!source) {
        resolve(zoomImage);
        return;
      }
      const finish = () => {
        zoomImage.removeEventListener('load', finish);
        zoomImage.removeEventListener('error', finish);
        zoomImage.removeAttribute('data-src');
        zoomLink.classList.remove('media--zoom-not-loaded');
        resolve(zoomImage);
      };
      zoomImage.addEventListener('load', finish, { once: true });
      zoomImage.addEventListener('error', finish, { once: true });
      zoomImage.src = source;
      if (zoomImage.complete) finish();
    });
    root.querySelectorAll('.cc-main-product .media--zoom:not([data-kexpdp-pan-ready])').forEach((zoomLink) => {
      zoomLink.dataset.kexpdpPanReady = 'true';
      const zoomImage = zoomLink.querySelector('.js-zoom-image');
      let pointerId = null;
      let startClientX = 0;
      let startClientY = 0;
      let startX = 50;
      let startY = 50;
      let positionX = 50;
      let positionY = 50;
      let dragged = false;
      const updatePosition = () => {
        if (zoomImage) zoomImage.style.objectPosition = `${positionX}% ${positionY}%`;
      };
      const finishDrag = (event) => {
        if (pointerId === null || (event.pointerId != null && event.pointerId !== pointerId)) return;
        if (zoomLink.hasPointerCapture?.(pointerId)) zoomLink.releasePointerCapture(pointerId);
        pointerId = null;
        zoomLink.classList.remove('is-kexpdp-mobile-dragging');
      };
      zoomLink.addEventListener('pointerdown', (event) => {
        if (!matchMedia('(max-width: 768px)').matches || !zoomLink.classList.contains('is-kexpdp-mobile-zoom')) return;
        event.preventDefault();
        pointerId = event.pointerId;
        startClientX = event.clientX;
        startClientY = event.clientY;
        startX = positionX;
        startY = positionY;
        dragged = false;
        zoomLink.setPointerCapture?.(pointerId);
        zoomLink.classList.add('is-kexpdp-mobile-dragging');
      });
      zoomLink.addEventListener('pointermove', (event) => {
        if (event.pointerId !== pointerId) return;
        event.preventDefault();
        const rect = zoomLink.getBoundingClientRect();
        const dx = event.clientX - startClientX;
        const dy = event.clientY - startClientY;
        if (Math.abs(dx) + Math.abs(dy) > 5) dragged = true;
        positionX = Math.min(100, Math.max(0, startX - (dx / rect.width) * 115));
        positionY = Math.min(100, Math.max(0, startY - (dy / rect.height) * 115));
        updatePosition();
      });
      zoomLink.addEventListener('pointerup', finishDrag);
      zoomLink.addEventListener('pointercancel', finishDrag);
      zoomLink.addEventListener('lostpointercapture', finishDrag);
      zoomLink.addEventListener('click', (event) => {
        if (!matchMedia('(max-width: 768px)').matches) return;
        event.preventDefault();
        if (dragged) event.stopPropagation();
      });
      zoomLink.kexpdpResetPan = () => {
        positionX = 50;
        positionY = 50;
        updatePosition();
      };
    });
    root.querySelectorAll('.kexpdp-mobile-zoom-toggle:not([data-kexpdp-ready])').forEach((button) => {
      button.dataset.kexpdpReady = 'true';
      button.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();
        const zoomLink = button.closest('.media')?.querySelector('.media--zoom');
        if (!zoomLink) return;
        const willZoom = !zoomLink.classList.contains('is-kexpdp-mobile-zoom');
        document.querySelectorAll('.cc-main-product .media--zoom.is-kexpdp-mobile-zoom').forEach((item) => {
          if (item === zoomLink) return;
          item.classList.remove('is-kexpdp-mobile-zoom');
          item.kexpdpResetPan?.();
          const itemToggle = item.closest('.media')?.querySelector('.kexpdp-mobile-zoom-toggle');
          itemToggle?.setAttribute('aria-pressed', 'false');
          itemToggle?.setAttribute('aria-label', 'Ampliar imagen');
        });
        if (willZoom) {
          button.setAttribute('aria-busy', 'true');
          await loadZoomImage(zoomLink);
          button.removeAttribute('aria-busy');
          zoomLink.kexpdpResetPan?.();
          zoomLink.classList.add('is-kexpdp-mobile-zoom');
        } else {
          zoomLink.classList.remove('is-kexpdp-mobile-zoom');
          zoomLink.kexpdpResetPan?.();
        }
        button.setAttribute('aria-pressed', String(willZoom));
        button.setAttribute('aria-label', willZoom ? 'Restablecer imagen' : 'Ampliar imagen');
      });
    });
    root.querySelectorAll('[data-kexpdp-video]:not([data-kexpdp-ready])').forEach((card) => {
      card.dataset.kexpdpReady = 'true';
      card.addEventListener('click', () => {
        if (card.classList.contains('is-playing')) return;
        const media = card.querySelector('.kexpdp-video__media');
        const id = card.dataset.youtubeId;
        const title = card.dataset.title || 'Video Kitchen Experts';
        if (!media || !id) return;
        const frame = document.createElement('iframe');
        frame.src = `https://www.youtube.com/embed/${encodeURIComponent(id)}?rel=0&autoplay=1`;
        frame.title = title;
        frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        frame.allowFullscreen = true;
        media.replaceChildren(frame);
        card.classList.add('is-playing');
      });
    });

    const syncProductStickyOffset = () => {
      const product = document.querySelector('.cc-main-product');
      if (!product) return;
      const stickyHeader = document.querySelector('.kexs-header-section');
      const headerHeight = stickyHeader ? Math.round(stickyHeader.getBoundingClientRect().height) : 0;
      product.style.setProperty('--kexpdp-sticky-top', `${Math.max(48, headerHeight + 12)}px`);
    };

    if (document.querySelector('.cc-main-product')) {
      syncProductStickyOffset();
      if (!window.kexpdpStickyResizeBound) {
        window.kexpdpStickyResizeBound = true;
        window.addEventListener('resize', syncProductStickyOffset, { passive: true });
      }
    }

    const samplingVideosSelector = '[id$="__sampling_videos"]:not([data-kexpdp-fallback-ready])';
    const samplingVideoSections = [
      ...(root.matches?.(samplingVideosSelector) ? [root] : []),
      ...root.querySelectorAll(samplingVideosSelector),
    ];
    samplingVideoSections.forEach((section) => {
      section.dataset.kexpdpFallbackReady = 'true';
      const deadline = Date.now() + 45000;
      let retryTimer;
      let sectionObserver;

      const stopWatching = () => {
        window.clearTimeout(retryTimer);
        sectionObserver?.disconnect();
      };

      const reelUpHasPlayableContent = (widget) => {
        if (widget.classList.contains('reelUp_playlist_loading')
          || widget.classList.contains('reelUp-loading-skeleton')
          || widget.querySelector('.reelUp_card_skeleton')) return false;

        return [...widget.querySelectorAll('.reelUp_card')].some((card) => (
          card.querySelector('video[src], iframe[src], img[src], [data-video-url], [style*="background-image"]')
        ));
      };

      const createNativeFallback = (widget) => {
        if (!widget || section.querySelector('.kexpdp-native-reels')) return false;

        const reelIds = [...widget.querySelectorAll('[data-reel-id]')]
          .map((slide) => String(slide.dataset.reelId || ''))
          .filter(Boolean);
        const availableVideos = Array.isArray(window.REELUP?.videos) ? window.REELUP.videos : [];
        const videosById = new Map(availableVideos.map((video) => [String(video.id), video]));
        const videos = reelIds
          .map((id) => videosById.get(id))
          .filter((video) => video?.short_video)
          .slice(0, 8);
        if (!videos.length) return false;

        const fallback = document.createElement('div');
        fallback.className = 'kexpdp-native-reels';
        fallback.setAttribute('role', 'region');
        fallback.setAttribute('aria-label', 'Videos de productos Kitchen Experts');

        const track = document.createElement('div');
        track.className = 'kexpdp-native-reels__track';
        const mediaObserver = 'IntersectionObserver' in window
          ? new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const video = entry.target;
              if (!video.getAttribute('src') && video.dataset.src) {
                video.preload = 'metadata';
                video.src = video.dataset.src;
              }
              mediaObserver.unobserve(video);
            });
          }, { root: track, rootMargin: '0px 220px' })
          : null;

        videos.forEach((item, index) => {
          const card = document.createElement('article');
          card.className = 'kexpdp-native-reels__card';

          const video = document.createElement('video');
          video.className = 'kexpdp-native-reels__video';
          video.dataset.src = item.short_video;
          if (item.thumbnail) video.poster = item.thumbnail;
          video.preload = index < 2 ? 'metadata' : 'none';
          video.controls = true;
          video.playsInline = true;
          video.muted = true;

          let mediaRetries = 0;
          video.addEventListener('error', () => {
            if (!video.isConnected || mediaRetries >= 2 || !video.dataset.src) return;
            mediaRetries += 1;
            window.setTimeout(() => {
              if (!video.isConnected) return;
              video.removeAttribute('src');
              video.load();
              video.src = video.dataset.src;
              video.load();
            }, mediaRetries * 1000);
          });

          const title = document.createElement('p');
          title.className = 'kexpdp-native-reels__title';
          title.textContent = String(item.title || 'Video Kitchen Experts').trim();

          video.addEventListener('play', () => {
            section.querySelectorAll('.kexpdp-native-reels__video').forEach((otherVideo) => {
              if (otherVideo !== video) otherVideo.pause();
            });
          });

          card.append(video, title);
          track.append(card);
          if (index < 2 || !mediaObserver) {
            video.src = video.dataset.src;
          } else {
            mediaObserver.observe(video);
          }
        });

        fallback.append(track);

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const desktopMotion = window.matchMedia('(min-width: 769px)');
        let autoTimer;
        let resizeTimer;

        const stopAuto = () => window.clearInterval(autoTimer);
        const advanceTrack = () => {
          if (!fallback.isConnected) {
            stopAuto();
            return;
          }
          const firstCard = track.querySelector('.kexpdp-native-reels__card');
          if (!firstCard) return;
          const styles = window.getComputedStyle(track);
          const gap = Number.parseFloat(styles.columnGap || styles.gap || 0) || 0;
          const step = firstCard.getBoundingClientRect().width + gap;
          const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          const nextLeft = track.scrollLeft >= maxScroll - step * .55 ? 0 : Math.min(maxScroll, track.scrollLeft + step);
          track.scrollTo({ left: nextLeft, behavior: 'smooth' });
        };
        const startAuto = () => {
          stopAuto();
          if (reduceMotion.matches || !desktopMotion.matches || track.scrollWidth <= track.clientWidth + 4) return;
          autoTimer = window.setInterval(advanceTrack, 4200);
        };

        fallback.addEventListener('mouseenter', stopAuto);
        fallback.addEventListener('mouseleave', startAuto);
        fallback.addEventListener('focusin', stopAuto);
        fallback.addEventListener('focusout', startAuto);
        track.addEventListener('pointerdown', stopAuto, { passive: true });
        track.addEventListener('pointerup', startAuto, { passive: true });
        window.addEventListener('resize', () => {
          window.clearTimeout(resizeTimer);
          resizeTimer = window.setTimeout(startAuto, 180);
        }, { passive: true });
        window.setTimeout(startAuto, 650);

        widget.hidden = true;
        widget.insertAdjacentElement('afterend', fallback);
        section.classList.add('kexpdp-native-reels-active');
        return true;
      };

      const ensureVideos = () => {
        if (!section.isConnected || section.querySelector('.kexpdp-native-reels')) {
          stopWatching();
          return;
        }

        const widget = section.querySelector('.reelUp_playlist_slider_static');
        if (widget && reelUpHasPlayableContent(widget)) {
          stopWatching();
          return;
        }

        if (widget && createNativeFallback(widget)) {
          stopWatching();
          return;
        }

        if (Date.now() >= deadline) {
          stopWatching();
          return;
        }

        window.clearTimeout(retryTimer);
        retryTimer = window.setTimeout(ensureVideos, 1000);
      };

      sectionObserver = new MutationObserver(() => {
        window.clearTimeout(retryTimer);
        retryTimer = window.setTimeout(ensureVideos, 120);
      });
      sectionObserver.observe(section, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'src', 'data-reel-id'],
      });
      retryTimer = window.setTimeout(ensureVideos, 1200);
    });
  };
  document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
